export function flexText () {
    function bty_flexText(wrapper) {

        wrapper = document.querySelectorAll(wrapper);

        let i;
        for (i = 0; i < wrapper.length; i++) {

            let child = wrapper[i].querySelector('span');

            if (child === undefined) {
                wrapper[i].childNodes.forEach(function (e) {
                    bty_flexText(wrapper[i], e);
                });
                return;
            }

            if (child.dataset === undefined || child.dataset.ignoreScale === 'true') {
                return;
            }

            child.style.letterSpacing = 0;
            child.style.wordWrap = 'none';

            var content = child.innerHTML;
            var original = content;
            content = content.replace(/(.{1})/g, '<span>$1</span>');
            content = content.replace(/(\s)/g, '&nbsp;');
            child.innerHTML = content;

            var letter_width = 0;
            var letters_count = 0;
            child.querySelectorAll('span').forEach(function (sub) {
                letter_width += sub.getBoundingClientRect().width;
                letters_count++;
            });

            var parentWidth = wrapper[i].getBoundingClientRect().width;

            // console.log(wrapper[i].getBoundingClientRect().width)

            var spacing = (parentWidth - letter_width) / (letters_count);

            child.innerHTML = original;
            child.style.letterSpacing = spacing + 'px';
            child.style.marginLeft = (spacing / 2) + 'px';
        }

    }

    document.addEventListener('DOMContentLoaded', function () {
        setTimeout(function () {
            bty_flexText('.letter_spacing');
        }, 100)

        window.addEventListener('resize', function () {
            setTimeout(function () {
                bty_flexText('.letter_spacing');
            }, 200)
        });
    });
};
